import { render, staticRenderFns } from "./deleteDishModal.vue?vue&type=template&id=5cf99fbb&scoped=true"
import script from "./deleteDishModal.vue?vue&type=script&lang=js"
export * from "./deleteDishModal.vue?vue&type=script&lang=js"
import style0 from "./deleteDishModal.vue?vue&type=style&index=0&id=5cf99fbb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf99fbb",
  null
  
)

export default component.exports